const stats = [
  { value: "28+", label: "精选影视作品" },
  { value: "15", label: "内容分类标签" },
  { value: "每日", label: "持续更新推荐" },
];

const features = [
  {
    icon: "ri-filter-3-line",
    title: "多维筛选",
    desc: "按类型、地区、年份自由组合筛选，快速找到想看的内容。",
  },
  {
    icon: "ri-search-eye-line",
    title: "全站搜索",
    desc: "关键词全文检索，支持按电影或电视剧类型进一步缩小范围。",
  },
  {
    icon: "ri-heart-3-line",
    title: "本地收藏",
    desc: "一键收藏心仪影片，数据保存在浏览器本地，随时查看。",
  },
  {
    icon: "ri-magic-line",
    title: "智能推荐",
    desc: "基于类型与主创的相似度，为你推荐更多可能喜欢的作品。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-500/10 border border-accent-500/40 px-3 py-1 text-xs text-accent-300">
            <i className="ri-movie-2-line" aria-hidden="true" />
            关于天堂电影网
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            为影迷打造的影视内容导航平台
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-400 leading-relaxed max-w-2xl">
            天堂电影网致力于为广大影视爱好者提供丰富、清晰、更新及时的影视资源导航。我们覆盖最新上映的电影与热播电视剧，辅以排行榜、专题推荐与智能筛选，帮助你轻松发现值得一看的作品，享受纯粹而高效的观影探索体验。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="/about"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 rounded-md border border-foreground-400/40 px-5 py-2.5 text-sm font-medium text-foreground-800 hover:border-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              联系我们
            </a>
          </div>
          <div className="mt-8 grid grid-cols-3 gap-4 max-w-lg">
            {stats.map((stat) => (
              <div key={stat.label}>
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">{stat.value}</p>
                <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex gap-3 p-4 rounded-lg bg-background-100 ring-1 ring-background-200/70"
            >
              <span className="w-10 h-10 shrink-0 rounded-md bg-secondary-800 text-accent-300 flex items-center justify-center text-xl">
                <i className={feature.icon} aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900">{feature.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}